import { StorageModule } from './storage';
let delCatalogue = () => {
}
export const ProcessModule = {
    getExecuteList () {
        return StorageModule.get('pl_execute_list', true) || [];
    },
    setExecuteList (execute_list) {
        StorageModule.set('pl_execute_list', execute_list);
    },
    clearExecuteList() {
        StorageModule.set('pl_execute_list', []);
    },
    delExecuteList(path) {
        delCatalogue(path);
        let execute_list = StorageModule.get('pl_execute_list') || [];
        execute_list = execute_list.filter((v) => (v.syncPath !== path));
        StorageModule.set('pl_execute_list', execute_list);
    },
    onDelCatalogue (fn) {
        delCatalogue = fn;
    }
}